// AuthContext.js
// AuthContext.jsx

import React, { createContext, useContext } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from 'firebase/compat/app';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const auth = firebase.auth();
  const [user] = useAuthState(auth);

  return (
    <AuthContext.Provider value={{ user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
